angular.module('pe4h').directive("topbar", ['$templateCache',
    function($templateCache) {
        return {
          restrict: 'E',
          replace: false,
          template: $templateCache.get('shared/components/topbar/topbar.html')
        };
    }
]);